import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React from 'react';
import { ekomiReviewsPropTypes } from './EkomiReviewsPropTypes';
import Container from '@Theme/natucare/components/Container/Container';
import Icon from '@Theme/natucare/components/Icon/Icon';
import Star from '@Theme/natucare/components/Star/Star';
import ReviewsList from './components/ReviewsList/ReviewsList';
import * as styles from './EkomiReviews.module.scss';
const EkomiReviews = _ref => {
  let {
    heading,
    infoText,
    seal,
    rating,
    numberOfRatings,
    reviews,
    showMoreButtonText
  } = _ref;
  if (!heading && !infoText && !seal && !rating && !numberOfRatings && !reviews) {
    return null;
  }
  const fullStars = Math.floor(rating.current);
  const halfStars = Math.round(rating.current - fullStars);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeader
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.rootHeading
  }, heading), infoText && /*#__PURE__*/React.createElement("div", {
    className: styles.rootInfo
  }, /*#__PURE__*/React.createElement(Icon, {
    classname: styles.rootInfoIcon,
    name: "info"
  }), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: infoText
    },
    className: styles.rootInfoText
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rootTiles
  }, seal && /*#__PURE__*/React.createElement("div", {
    className: `${styles.rootTile} ${styles.rootSeal}`
  }, /*#__PURE__*/React.createElement("a", {
    href: seal.href,
    target: "_blank",
    rel: "noopener noreferrer",
    title: seal.image.title
  }, /*#__PURE__*/React.createElement("img", {
    src: seal.image.src,
    className: styles.rootSealLogo,
    alt: seal.image.alt
  }))), rating && /*#__PURE__*/React.createElement("div", {
    className: `${styles.rootTile} ${styles.rootRating}`
  }, /*#__PURE__*/React.createElement("a", {
    href: rating.href,
    target: "_blank",
    rel: "noopener noreferrer"
  }, rating.current && /*#__PURE__*/React.createElement("div", {
    className: styles.rootRatingStars
  }, _toConsumableArray(Array(5)).map((_, index) => {
    const value = 5 - index;
    const filled = value <= fullStars;
    const half = value === fullStars + 1 && halfStars > 0;
    return /*#__PURE__*/React.createElement(Star, {
      classname: styles.rootRatingStarsStar,
      "data-value": value,
      filled: filled,
      half: half,
      key: value
    });
  }))), rating.current && rating.max && /*#__PURE__*/React.createElement("div", {
    className: styles.rootRatingText
  }, rating.current, "/", rating.max), rating.title && /*#__PURE__*/React.createElement("div", {
    className: styles.rootRatingTitle
  }, rating.title)), numberOfRatings && /*#__PURE__*/React.createElement("div", {
    className: `${styles.rootTile} ${styles.rootNumberOfRatings}`
  }, numberOfRatings.number && /*#__PURE__*/React.createElement("div", {
    className: styles.rootNumberOfRatingsNumber
  }, numberOfRatings.number), numberOfRatings.title && /*#__PURE__*/React.createElement("div", {
    className: styles.rootNumberOfRatingsTitle
  }, numberOfRatings.title)))), reviews && /*#__PURE__*/React.createElement("div", {
    className: styles.rootReviews
  }, /*#__PURE__*/React.createElement(ReviewsList, {
    reviews: reviews,
    showMoreButtonText: showMoreButtonText
  }))));
};
export default EkomiReviews;